//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ActionTiny } from '@backmarket/design-system'

import { trackClick } from '@tracking/events'

import { DATA_SELECTOR_ATTRIBUTE_FOR_SEO } from './Tags.constants'

export default {
  components: {
    ActionTiny,
  },
  props: {
    tags: {
      type: Array,
      required: true,
    },
  },
  computed: {
    dataSelectorAttribute: () => DATA_SELECTOR_ATTRIBUTE_FOR_SEO,
  },
  methods: {
    trackClick(tag) {
      trackClick({ zone: 'tags', name: `product-tag-${tag.slug}` })
    },
  },
}
